/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import './ComingSoonPage.css';

export default function ComingSoonPage() {
  return (
    <div className="coming-soon-page bg-primary-light">
      <div className="section-title text-center">
        <h1 className="title">Coming Soon</h1>
        <p className="description">
          We&apos;re working on something amazing. Stay tunned!!!
        </p>
      </div>
    </div>
  );
}
